export const family = {
  name: 'Vehda',
  email: 'vehda.offical@gmail.com'
}
